var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"absolute full-width full-height blue",attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"fs-32 white--text pb-4"},[_vm._v("Details")]),_c('v-btn',{attrs:{"dark":"","depressed":"","color":"ycmd-black"},on:{"click":function($event){return _vm.changeView('list-view')}}},[_vm._v("Back")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }